//글자수 자르기
export const textCut = (text, leng) => {
  return text.length >= leng ? text.substr(0, leng - 3) + ".." : text;
};

// null 데이터 default text 설정
export const nullChecker = (data, text = "없음") => {
  if (data === null || data === undefined || data === "" || data.length === 0) {
    return text;
  } else {
    return data;
  }
};
// null 데이터 default 0으로 설정
export const nulltoZero = (data) => {
  if (
    data === null ||
    data === undefined ||
    data === "" ||
    typeof data !== "number" ||
    isNaN(data) ||
    data === Infinity
  ) {
    return 0;
  } else {
    return data;
  }
};

export const adminValueCheck = (value) => {
  return value !== null && Array.isArray(value) && value[0] === "*";
};

export const passRule = /^([\w\.\_\-])*[a-zA-Z0-9]+([\w\.\_\-])*([a-zA-Z0-9])+([\w\.\_\-])+@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/;

export const emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

// 숫자만 입력 연산
export const numberRule = /^[0-9]+$/;

// 숫자 콤마연산
export const priceResult = (price) => {
  let result = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return result;
};

// 숫자 만단위 억단위 변환
export const formatKR = (number) => {
  var inputNumber = number < 0 ? false : number;
  var unitWords = ["", "만", "억", "조", "경"];
  var splitUnit = 10000;
  var splitCount = unitWords.length;
  var resultArray = [];
  var resultString = "";

  for (var i = 0; i < splitCount; i++) {
    var unitResult =
      (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  for (var i = 0; i < resultArray.length; i++) {
    if (!resultArray[i]) continue;
    resultString = String(resultArray[i]) + unitWords[i] + resultString;
  }

  return resultString;
};

// 숫자 만단위 억단위 변환
export const sexualCheck = (sex = "Boy") => {
  if (sex === "boy") {
    return "남성";
  } else if (sex === "Girl") {
    return "여성";
  } else {
    return "남성";
  }
};

export const ageTickFormatter = (data) => {
  switch (data) {
    case "10세":
      return "9-10";
    case "9세":
      return "8-9";
    case "8세":
      return "7-8";
    case "7세":
      return "6-7";
    case "6세":
      return "5-6";
    case "5세":
      return "4-5";
    case "4세":
      return "3-4";
    case "3세":
      return "2-3";
    case "2세":
      return "1-2";
    case "1세":
      return "0-1세";
    default:
      break;
  }
  return "";
};
export const ageTickFormatterCase2 = (data) => {
  switch (data) {
    case "10세":
      return "9-10세";
    case "9세":
      return "8-9세";
    case "8세":
      return "7-8세";
    case "7세":
      return "6-7세";
    case "6세":
      return "5-6세";
    case "5세":
      return "4-5세";
    case "4세":
      return "3-4세";
    case "3세":
      return "2-3세";
    case "2세":
      return "1-2세";
    case "1세":
      return "0-1세";
    default:
      break;
  }
  return "";
};

export const sexualTickFormatter = () => {};

const filterMode = ["ALL_FILTER", "ALL_ADVERTISER", "ALL_IMG", "ONE_IMG"];

export const conditionCase = (advertiser, ad, img) => {
  if (advertiser === 0) {
    return filterMode[0];
  } else {
    if (ad === 0) {
      return filterMode[1];
    } else {
      if (img === null) {
        return filterMode[2];
      } else {
        return filterMode[3];
      }
    }
  }
};

/* Filter Case별 정리
  ALL_FILTER : 광고주 전체
  ALL_ADVERTISER : 광고주 선택 ->  광고상품 전체 상태 
  ALL_IMG : 광고상품 전체
  ONE_IMG : 하나의 이미지만 선택시
*/
export const filterMap = {
  ALL_FILTER(filterData) {
    return filterData.stats.total;
  },
  ALL_ADVERTISER(filterData) {
    return filterData.stats.total.filter(
      (data) => data.advertiser_id === filterData.target.advertiser
    );
  },
  ALL_IMG(filterData) {
    let imgListCheck = filterData.img_banners.map((data) => {
      return data.ad_id;
    });
    return filterData.stats.total.filter(
      (data) =>
        data.advertiser_id === filterData.target.advertiser &&
        imgListCheck.findIndex((item) => data.ad_id === item) !== -1
    );
  },
  ONE_IMG(filterData) {
    return filterData.stats.total.filter(
      (data) =>
        data.advertiser_id === filterData.target.advertiser &&
        data.ad_id === filterData.target.img
    );
  },
};

export const adETCList = (data = 1) => {
  let result = null;
  switch (data) {
    case 1:
      break;

    default:
      break;
  }
  return result;
};

export const etcMap = [
  { index: 1, no: 1, value: "1", name: "하단배너" },
  { index: 2, no: 2, value: "2", name: "종료배너" },
  { index: 3, no: 3, value: "3", name: "웰컴배너" },
  { index: 4, no: 4, value: "4", name: "모달광고" },
  { index: 5, no: 5, value: "5", name: "텍스트배너" },
  { index: 6, no: 6, value: "6", name: "스플래시광고" },
  { index: 7, no: 7, value: "7", name: "리워드 광고" },
  { index: 8, no: 8, value: "8", name: "비대면 진료" },
  { index: 9, no: 9, value: "9", name: "스크린 전면 광고" },
  { index: 10, no: 13, value: "13", name: "열관리 탭 배너" },
  { index: 11, no: 14, value: "14", name: "체온가이드 배너" },
  { index: 12, no: 15, value: "15", name: "오늘 유행 배너" },
];
export const etcfilterResult = (data = 1) => {
  const filterData = etcMap.filter((item) => data === item.no)[0];
  const result = filterData !== undefined ? filterData.name : "베너";
  return result;
};
